export const getBaseUrl = (url: string) => {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.origin; // Includes protocol, hostname, and port (if specified)
    } catch (error) {
        console.error('Invalid URL', error);
        return null;
    }
}